<a [routerLink]="$action().url">
  <button kendoButton type="button" themeColor="error" [disabled]="$disabled()" [svgIcon]="$cancelIcon()" (click)="onClick($event)">
    @if ($disabled()) {
      <kendo-loader size="small" />
    }
    Cancel
  </button>
</a>
